import { GetterTree } from 'vuex';
import { ApplicationsState } from './types';

const getters: GetterTree<ApplicationsState, any> = {
  job: (state) => {
    return state.job;
  },

  applicationDetails: (state) => {
    return state.applicationDetails;
  },

  applicantCareTypeKey: (state) => {
    const careType = state.applicationDetails.job?.careType;

    switch (careType) {
      case 'PET_CARE':
        return 'petCare';
      case 'COMPANION_CARE':
        return 'companionCare';
      case 'HOUSEKEEPING':
        return 'housekeeping';
      case 'NANNY':
        return 'nanny';
      default:
        return 'babysitter';
    }
  },

  applicantsExperienceKey: (state) => {
    const careType = state.applicationDetails.job?.careType;

    switch (careType) {
      case 'PET_CARE':
        return 'petCareYearsExperience';
      case 'COMPANION_CARE':
        return 'companionCareYearsExperience';
      case 'HOUSEKEEPING':
        return 'housekeepingYearsExperience';
      default:
        return 'yearsExperience';
    }
  },

  allStatusTotal: (state): number => {
    return state.allStatusTotal.applications.totalCount;
  },

  receivedTotal: (state): number => {
    return state.receivedTotal.applications.totalCount;
  },

  interestedTotal: (state): number => {
    return state.interestedTotal.applications.totalCount;
  },

  notAFitTotal: (state): number => {
    return state.notAFitTotal.applications.totalCount;
  },

  isMobile: (): Function => {
    return () => window.innerWidth < 1024;
  },

  toastNotificationMessage: (state): string => {
    return state.toastNotificationMessage;
  },

  showMessageSentNotification: (state): boolean => {
    return state.showMessageSentNotification;
  },

  showApplicationLoading: (state): boolean => {
    return state.showApplicationLoading;
  },
};

export default getters;
